import { render, staticRenderFns } from "./IconeSimplesRedondoComLabel.vue?vue&type=template&id=55df1f7a&scoped=true"
import script from "./IconeSimplesRedondoComLabel.vue?vue&type=script&lang=js"
export * from "./IconeSimplesRedondoComLabel.vue?vue&type=script&lang=js"
import style0 from "./IconeSimplesRedondoComLabel.vue?vue&type=style&index=0&id=55df1f7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df1f7a",
  null
  
)

export default component.exports